import { useContext, useRef } from "react";
import { useOutsideClickHandler } from "../../../../Hooks/useOutsideClick";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../../Features/inventoryManagementSlice";
import { EditSizeChartContext } from "../../../../Context/EditSizeChartContext";
import ColumnRemoveModal from "./ColumnRemoveModal";

function ColumnRemoveModalContainer() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const { sizeChartName } = useContext(EditSizeChartContext);

    return (
        <div ref={wrapperRef} className={`w-fit max-w-[60%] bg-white border border-[#EAEAEA] shadow-[0px_0px_12px_0px_#0000003D] rounded-[9px] p-4 flex flex-col gap-4`}>
            <div className="w-full flex flex-col gap-3">
                {
                    sizeChartName && 
                    <div className="flex items-center justify-between">
                        <h1 className='font-semibold text-2xl text-[#121212]'>{sizeChartName}</h1>
                    </div>
                }

                <ColumnRemoveModal />
            </div>
        </div>
    )
}

export default ColumnRemoveModalContainer;
